import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { UI } from '../ui';
import { HEX_COLOR_RE } from './merchant-config.models';

/** `#RRGGBB` text input with a native colour swatch. Empty is allowed when `optional`. */
@Component({
  selector: 'mm-color-field',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, ...UI],
  template: `
    <label class="flex flex-col gap-1 text-[0.8125rem] font-semibold text-fg">
      <span>{{ label() }}</span>
      <span class="flex items-center gap-2">
        <input
          type="color"
          class="h-9 w-10 cursor-pointer rounded border border-border bg-card p-0.5"
          [value]="swatch()"
          [disabled]="disabled()"
          [attr.aria-label]="label() + ' picker'"
          (input)="value.set($any($event.target).value.toUpperCase())"
        />
        <input
          uiInput
          placeholder="#RRGGBB"
          maxlength="7"
          [ngModel]="value()"
          (ngModelChange)="value.set($event)"
          [disabled]="disabled()"
        />
      </span>
      @if (invalid()) {
        <span class="text-xs font-normal text-danger-fg">Use a #RRGGBB colour.</span>
      }
    </label>
  `,
})
export class ColorFieldComponent {
  readonly label = input.required<string>();
  readonly disabled = input(false);
  readonly optional = input(false);
  readonly value = model('');

  readonly swatch = computed(() => (HEX_COLOR_RE.test(this.value()) ? this.value() : '#000000'));
  readonly invalid = computed(() => {
    const v = this.value();
    return v === '' ? !this.optional() : !HEX_COLOR_RE.test(v);
  });
}
